var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ButtonLink, Button, DropdownMenuItem } from "./..";
import { strToID } from "../../utils";
export var UserDropdownAction = function (_a) {
    var text = _a.text, to = _a.to, opensLinkInNewTab = _a.opensLinkInNewTab, onClick = _a.onClick, icon = _a.icon, _b = _a.hasDividerAbove, hasDividerAbove = _b === void 0 ? false : _b;
    var sharedProps = {
        id: strToID(text),
        emphasis: 'low',
        scale: 'sm',
        lss: {
            p: 0,
            mx: 'sm',
            width: "calc(100% - 16px)",
            textScale: 'control',
            textDecoration: 'none',
            color: 'secondary500',
            ':focus': {
                outlineWidth: '2px'
            },
            ':not([disabled]):hover': {
                textDecoration: 'none'
            }
        }
    };
    var containerLss = {
        borderTop: hasDividerAbove ? 'regular' : 'none',
        borderTopColor: 'gray300',
        py: 'md'
    };
    return to ? (React.createElement(ButtonLink, __assign({}, sharedProps, { to: to, target: opensLinkInNewTab ? '_blank' : undefined, onClick: onClick }),
        React.createElement(DropdownMenuItem, { icon: icon, text: text, containerLss: containerLss }))) : typeof onClick === 'function' ? (React.createElement(Button, __assign({}, sharedProps, { type: "button", onClick: onClick }),
        React.createElement(DropdownMenuItem, { icon: icon, text: text, containerLss: containerLss }))) : null;
};
//# sourceMappingURL=UserDropdownAction.js.map